const newsApi = {
  GETNEWSDATA: '/news/getNews', //获取所有新闻
  DELECTNEWITEM: '/news/deleteNews', //删除某条新闻
  ADDNEWSITEM: '/news/addNews', //添加某条新闻
  GETDETAILNEWS: '/news/getNewsById', //获取某条新闻的详情
  UPDATENEWS: '/news/updateNews', //更新新闻
  TOPNEWITEM: '/news/topNews', //置顶新闻
  GETTYPES: '/repositoryType/getTypes', //获取全部分类
  QAALLLIST: '/repository/getAll', //获取ai全部问答数据
  EDITQAITEM: '/repository/updateRepository', //编辑问答问题
  ADDQAITEMITEM: '/repository/addRepository', //添加一个问答
  DELETEQAITEM: '/repository/deleteRepository' //删除一个问答
}
export default newsApi
